import dadosImg from '../../assets/img/semDados.png'
import dadosGraficoProps from '../../interfaces/propsNenhumDadoGrafico'
import './nenhumdadografico.css'

function NenhumDadoGrafico (props: dadosGraficoProps ) {

    return (
        <div className = 'semDadoGraficoContainer'>
            <img src = {dadosImg} alt = ''/>
            <p>{props.texto} <br/> {props.subtexto}</p>
        </div>
    )
}

export default NenhumDadoGrafico

